import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Training from './pages/Training';
import Services from './pages/Services';
import Products from './pages/Products';
import Team from './pages/Team';
import Contact from './pages/Contact';
import './styles/App.css';
import './styles/animations.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  // Listen for navigation events from the Home component
  useEffect(() => {
    const handleNavigate = (event) => {
      setCurrentPage(event.detail.page);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    
    window.addEventListener('navigate', handleNavigate);
    
    // Also expose changePage globally
    window.changePage = (page) => {
      setCurrentPage(page);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    
    return () => {
      window.removeEventListener('navigate', handleNavigate);
      delete window.changePage;
    };
  }, []);

  const renderPage = () => {
    switch(currentPage) {
      case 'home': return <Home />;
      case 'about': return <About />;
      case 'training': return <Training />;
      case 'services': return <Services />;
      case 'products': return <Products />;
      case 'team': return <Team />;
      case 'contact': return <Contact />;
      default: return <Home />;
    }
  };

  return (
    <div className="App">
      <Navbar setCurrentPage={setCurrentPage} currentPage={currentPage} />
      <main>{renderPage()}</main>
      <Footer />
    </div>
  );
}

export default App;